import gql from 'graphql-tag';

export const CreateDispatchSummary = gql`
  mutation CreateDispatchSummaryBulk($input: CreateDispatchSummaryBulkInput!) {
    createDispatchSummaryBulk(input: $input) {
      output {
        error
        node {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          callVolume
          chatVolume
          dispatcherId
          dispatcherShift
          dispatcherDayOverview
          dispatcherPassdown
          dispatcherEightByEightIssue
          dispatcherAssetCamerasWorking
          dispatcherAssetCamerasWorkingNotes
          dispatcherSoftwareIssues
          dispatcherServiceIssues
          dispatcherStationVansIssues
          dispatcherStation
          dispatcherWasThereEightByEightIssue
          commentsFaxallCheck
          commentsRepeatSpeedingOffenders
          commentsRepeatDistractedOffenders
          manifestsTaxis
          manifestsTrainingIssues
          manifestsDrivingIssues
        }
      }
    }
  }
`;
